import { Action, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import { IFieldDefinitions } from '@pazion/pazion-core/src/models/settings-model';


export interface ISettingsState {
  fieldDefinitions: IFieldDefinitions;
}


@Module({ name: 'settings', namespaced: true })
export default class SettingsModule extends VuexModule implements ISettingsState {

  public fieldDefinitions = {} as IFieldDefinitions;

  @MutationAction({ mutate: ['fieldDefinitions'] })
  public async getSettingsFieldsDefinition(fieldSettings: IFieldDefinitions)
  : Promise<{ fieldDefinitions: IFieldDefinitions }> 
  {
    return { fieldDefinitions: fieldSettings };
  }


}//